<template>
  <div class="lg-flex justify-around">
    <div class="fixed left-0 bottom-0 p2 xs-hide sm-hide md-hide">
      <h1 class="h4 m0 regular line-height-2">{{ title }}</h1>
    </div>
    <gallery :data="images" :preload="true" :project-view="true" :key="slug"></gallery>
    <div v-if="info" class="lg-px2 lg-py0 project-info overflow-auto">
      <p class="lg-hide pt1 line-height-2">{{ title }}</p>
      <div v-html="info.text" class="justify"></div>
    </div>

    <div v-if="nextProject" class="fixed right-0 bottom-0 p2 xs-hide sm-hide md-hide">
      <router-link :to="`/projects/${nextProject.post_name}`" class="h4 m0 regular line-height-2">Next project</router-link>
    </div>
  </div>
</template>

<script>
  import store from '@/store'
  import Gallery from '@/components/Gallery'

  export default {
    name: 'project',
    metaInfo () {
      return {
        title: this.title,
        titleTemplate: '%s · Maich Swift Architects'
      }
    },
    computed: {
      slug () {
        return this.$route.params.slug
      },
      project () {
        // return store.state.currentProject
        return store.state.projects[this.slug]
      },
      slides () {
        if (!this.project) return []
        return this.project.acf.slides || []
      },
      images () {
        return this.slides.filter(i => i.acf_fc_layout === 'image')
      },
      info () {
        return this.slides.find(i => i.acf_fc_layout === 'text')
      },
      title () {
        return this.project.post_title || this.project.title.rendered
      },
      nextProject () {
        return store.getters.nextProject
      }
    },
    beforeRouteEnter (to, _from, next) {
      const { slug } = to.params
      const { type } = to.meta
      store.dispatch('getProject', { slug, type }).then(() => {
        next()
      })
    },
    beforeRouteUpdate (to, _from, next) {
      const { slug } = to.params
      const { type } = to.meta
      store.dispatch('getProject', { slug, type }).then(() => {
        setTimeout(next, 100)
      })
    },
    components: { Gallery }
  }
</script>



// WEBPACK FOOTER //
// src/components/Project.vue